import React from 'react';
import {
  CardHcd,
  CenterHcd,
} from '@maiia/model/generated/model/api-patient/api-patient';
import { pick } from 'lodash';
import { Typography } from '@mui/material';
import { IconPractitioner } from '@maiia/design-system';
import Link from '../../atoms/Link/Link';
import Text from '../../atoms/Text/Text';
import Map from '../Map/Map';
import { Trans, useTranslation } from '@/src/i18n';

import Avatar from '../../atoms/Avatar/Avatar';
import {
  getAddress,
  getCardMainPicture,
  hasAnyVisibleAddress,
} from '../../utils/card';

type Props = {
  card: CardHcd;
  items: Array<CenterHcd>;
};

const ChildCenters = ({ card, items }: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <Text
        variant="paragraph"
        size="large"
        className="title-icon"
        component="h2"
        iconComponent={<IconPractitioner />}
      >
        {t('center_list')}
      </Text>
      <div className="wrapper-list">
        <Text variant="paragraph" component="p">
          <Trans
            i18nKey="hcd_center_childcenters_subtitle"
            values={{
              name:
                card.center?.name ?? t('common:hcd_center_centername_fallback'),
              count: items.length,
            }}
            components={[<span key="highlight" className="highlight" />]}
          />
        </Text>
        <div className="center-list">
          {items.map(center => (
            <div key={center.id} className="center-list-item">
              <Avatar source={getCardMainPicture(center, 'CENTER')} />
              <div className="center-infos">
                {center.url ? (
                  <Link href={center.url} legacyBehavior>
                    <Typography
                      color="primary"
                      variant="h6"
                      sx={theme => ({
                        // TODO : Done quickly, integrate it in a separate custom
                        //  Typography component or in the theme
                        fontSize: theme.typography.body1.fontSize,
                        fontWeight: 500,
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        color: theme.palette.primary.dark,
                        '&:hover': {
                          color: theme.palette.primary.main,
                          textDecoration: 'none',
                        },
                      })}
                    >
                      {center.name}
                    </Typography>
                  </Link>
                ) : (
                  center.name
                )}

                <Text variant="paragraph" component="p">
                  {center.publicInformation?.isAddressVisible &&
                    getAddress(center)}
                </Text>
                {!!center.speciality && (
                  <Text variant="paragraph" component="p" className="spe">
                    <Trans
                      i18nKey="hcd_center_childcenters_speciality"
                      values={{ speciality: center.speciality?.name }}
                    />
                  </Text>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="map">
        {hasAnyVisibleAddress(card) && (
          <Map
            items={items.filter(center =>
              Boolean(center.publicInformation?.address),
            )}
            initialLocation={pick(card?.publicInformation?.address?.location, [
              'x',
              'y',
            ])}
            showPharmacies
          />
        )}
      </div>
    </>
  );
};
export default ChildCenters;
